import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import {
  clearCompanyOwnerAuthFlow,
  getCompanyOwnerAuthUser,
} from '../../services/storage/companyOwnerFlow';
import { getNonCompanyAccessFallbackRoute, isCompanyOwnerUser } from '../../utils/companyOwner';

const CompanyOwnerRoute: React.FC = () => {
  const location = useLocation();
  const companyOwnerUser = getCompanyOwnerAuthUser();

  if (!isCompanyOwnerUser(companyOwnerUser)) {
    clearCompanyOwnerAuthFlow();
    return <Navigate replace state={{ from: location }} to={getNonCompanyAccessFallbackRoute()} />;
  }

  return <Outlet />;
};

export default CompanyOwnerRoute;
